<div class="sos-content">
  <h4>Documentos</h4>
  <div *ngFor="let item of acoes; let i = index">
    <div *ngIf="item.acao === 'GRAVAR_DOCS'">
      <app-upload-arquivos [isOrigemSos]="true" [documentos]="item.docs" [idFicha]="idFicha" [cliente]="cliente" [hideInfo]="true"></app-upload-arquivos>
    </div>
  </div>
</div>